/**
 * Retrieves the top five items and sorts the rest by the 'label' property.
 * Includes an 'underline' as a separator unless there are five or fewer items.
 *
 * @param {Array} items - Array of objects with a 'label' property.
 * @returns {Array} - The top five items, an 'underline', and the sorted remaining items.
 */
export const getTopFiveAndSortRemainingItemsByLabel = (items) => {
  const topFive = items.slice(0, 5)

  if (items.length <= 5) {
    return topFive
  }

  const sortedRest = items
    .slice(5)
    .sort((a, b) => a.label.localeCompare(b.label))

  return [...topFive, 'underline', ...sortedRest]
}
